<div class="min-h-screen flex flex-col bg-gray-50">
  <!-- Topbar -->
  <div
    class="fixed top-0 right-0 h-16 bg-white shadow-sm z-50 flex items-center justify-between px-6 transition-all duration-300"
    [ngClass]="{
      'md:left-64 w-[calc(100%-16rem)]': sidebarVisible && !isLoginPage,
      'left-0 w-full': !sidebarVisible || isLoginPage
    }"
  >
    <div class="flex items-baseline space-x-4">
      <button
        class="text-gray-600 hover:text-gray-900 focus:outline-none cursor-pointer"
        (click)="toggleSidebar()"
        *ngIf="!isLoginPage"
      >
        <i class="pi pi-bars text-xl"></i>
      </button>
      <h1 class="text-[16px] font-semibold text-gray-900 uppercase">
        {{ isLoginPage ? "10B5-1" : currentTitle }} <span *ngIf="issuerName"> - {{ issuerName }}</span>
      </h1>
    </div>

    <!-- User Dropdown -->
    <div class="relative" *ngIf="!isLoginPage">
      <div
        class="flex items-center cursor-pointer space-x-2"
        (click)="toggleUserDropdown()"
      >
         <span class="countdownElement token-expiry" id="demo"></span>

        <div
          class="bg-[rgb(0,21,41)] text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold"
        >
          {{ getInitials(username) }}
        </div>
        <!-- <span class="hidden sm:inline text-gray-700 font-medium">
          {{ username }}
        </span> -->
        <i class="pi pi-chevron-down text-gray-500"></i>
      </div>

      <div
        class="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-md py-2 z-50 px-2"
        *ngIf="userDropdownVisible"
      >
        <button
          class="w-full text-left px-2 py-2 text-gray-700 hover:bg-gray-100 flex items-center gap-2 cursor-pointer"
          (click)="logout()"
        >
          <i class="pi pi-sign-out"></i> SignOut
        </button>
      </div>
    </div>
  </div>

  <!-- Sidebar -->
  <div
    class="fixed top-0 left-0 h-full w-64 bg-[rgb(0,21,41)] shadow-md z-40 transition-transform duration-300 ease-in-out"
    [ngClass]="{
      '-translate-x-full': !sidebarVisible,
      'translate-x-0': sidebarVisible,

    }"
    *ngIf="!isLoginPage"
  >
    <aside class="w-64 text-white p-4 space-y-2 mt-14">
      <div class="text-xl text-center font-bold mb-6">{{ title }}</div>

      <ul class="space-y-2">
        <li
          routerLink="/inbox"
          routerLinkActive="bg-[#1f273b]"
          class="flex items-center gap-2 p-2 hover:bg-[#1f273b] rounded cursor-pointer"
        >
          <i class="pi pi-home"></i>
          <span>INBOX</span>
        </li>
        <li
          routerLink="/mapping"
          routerLinkActive="bg-[#1f273b]"
          class="flex items-center gap-2 p-2 hover:bg-[#1f273b] rounded cursor-pointer"
        >
          <i class="pi pi-file"></i>
          <span>MAPPING</span>
        </li>
        <li
          routerLink="/quality-gate"
          routerLinkActive="bg-[#1f273b]"
          class="flex items-center gap-2 p-2 hover:bg-[#1f273b] rounded cursor-pointer"
        >
          <i class="pi pi-chart-bar"></i>
          <span>Quality Gates</span>
          <span *ngIf="_newEntries > 0" class="badge">{{ _newEntries }}</span>
        </li>

        <li
          routerLink="/exception-handling"
          routerLinkActive="bg-[#1f273b]"
          class="flex items-center gap-2 p-2 hover:bg-[#1f273b] rounded cursor-pointer"
        >
          <i class="pi pi-exclamation-triangle"></i>
          <span>Exception Handling</span>
        </li>
  <li
          routerLink="/insider-trading-plans"
          routerLinkActive="bg-[#1f273b]"
          class="flex items-center gap-2 p-2 hover:bg-[#1f273b] rounded cursor-pointer"
        >
          <i class="pi pi-chart-line"></i>
          <span>Insider Trading Plans</span>
        </li>
      </ul>
      <div
        class="mt-6 border-t border-gray-700 py-4 px-2 flex flex-col items-center bg-[#1a2639] rounded-lg shadow-inner"
      >
        <div class="text-xs uppercase tracking-wide text-gray-400 mb-1">
          Previous Filing
        </div>
        <div
          class="text-sm font-bold text-white px-3 py-1 rounded-full shadow-sm"
        >
          <!-- {{ previousFilingId || "N/A" }} -->
          <a
            *ngIf="previousFilingId; else empty"
            [href]="
              '/inbox?filingId=' +
              previousFilingId +
              '&filingState=' +
              previousFilingState
            "
            [style.color]="'#4a90e2'"
            [style.cursor]="'pointer'"
            rel="noopener"
            target="_blank"
            >{{ previousFilingId }}</a
          >
          <ng-template #empty>
            <span>-</span>
          </ng-template>
        </div>
      </div>
    </aside>
  </div>

  <!-- Main Content -->
  <div
    class="flex-1 mt-14 transition-all duration-300 ease-in-out"
    [ngClass]="{
      'md:ml-64': sidebarVisible && !isLoginPage,
      'ml-0': !sidebarVisible || isLoginPage
    }"
  >
    <div class="p-6">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
